import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";
import NavCampaign from "./NavCampaign";
const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-barrowcleft.webp"
            alt="Barrowcleft"
          />
        </p>
        <strong>
          Residences and markets for the farmers who work the fields and
          eeleries.
        </strong>{" "}
        Barrowcleft is the home to the <strong>laborers</strong> and
        <strong>overseers of the Ministry of Preservation</strong> who attend
        the radiant energy farms of Doskvol. It is a dusty,{" "}
        <strong>rural</strong> district, with simple{" "}
        <strong>wooden buildings</strong> of only one or two stories and{" "}
        <strong>wide dirt roads</strong> to accommodate large cargo wagons. The
        farmers of Barrowcleft are organized into{" "}
        <strong>tight-knit family-based clans</strong>that are proud of their
        vital role in the city's welfare and hold themselves apart from the
        “city folk” across the river. Outsiders are welcome here for honest
        trade, but are met with a cold suspicion otherwise.
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-barrowcleft.webp"
          alt="Barrowcleft"
        />
        <table>
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Nutshell.</strong> Radiant farms, market, eeleries,
                Mustang Inn.
                <br />
                <strong>Scene:</strong> Farmers trudging to and from work.
                Tradespeople crafting simple goods. Merchants selling their
                wares. Heavy-laden cargo wagons transporting food into the city.
                Vigilant deputies surveying the fields from their watchtowers.
                <br />
                <strong>Streets:</strong> Smooth dirt roads, drainage ditches.
                <br />
                Black Hill Road, Mill Street, Porter Street.
                <br />
                <strong>Buildings:</strong> Low, wide wooden structures. Barns.
                Animal pens. Stone mills. Hilltop manors for the Overseers.
                Crowded apartments, towers, and market stalls along Barrow
                Bridge.
                <br />
                <strong>Factions</strong>
                <ul>
                  <li> 1. Ministry of Preservation</li>
                  <li>
                    {" "}
                    2. The Hive
                    <br />
                  </li>
                  <li> 3. The Billhooks</li>
                </ul>
              </td>
              <td>
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-barrowcleft.webp"
                  alt="Barrowcleft market"
                />
                <br />
                <em>
                  Barrowcleft market is one of the best marketplaces in the
                  city, but criminal types draw lots of unwanted attention.
                </em>
                <br />
                <em>
                  You can take <strong>+1d</strong> to acquire an asset here,
                  but also accrue <strong>+2 heat</strong>.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Barrowcleft Locations</h1>{" "}
        <strong>
          <u>Barrow Bridge</u>
        </strong>
        : One of several residential bridges in the city. The bridge is lined
        with homes, shops, and merchant stalls. Families of river-fishers work
        from ramshackle wooden huts along the banks on either side. They hunt
        the large and dangerous wild river eels that gather to feed on refuse
        near the channel to the sea. <br />
        <strong>
          <u>Barrowcleft Market</u>
        </strong>{" "}
        : This open air marketplace provides a place for the radiant energy
        farms to sell fresh produce and goods made from their crops. Other
        related vendors have also sprung up here, including brewers and
        distillers, weavers, dyers, and goat breeders. The tough and close-knit
        people of Barrowcleft have managed to keep criminal influence out of
        their market and it’s famous as a **rare place for fair trade** in the
        city. <br />
        <strong>
          <u>Lightning Tower</u>
        </strong>{" "}
        : The lightning towers of Doskvol are marvels of electroplasmic
        engineering, requiring constant attention from the powerful Sparkwrights
        guild. The largest towers are over 200 feet tall and include their own
        internal generators to provide power to the lightning barrier that keeps
        the ravenous spirits of the deathlands out of the city. <br />
        <strong>
          <u>Radiant Energy Farm</u>
        </strong>{" "}
        : The wondrous power of radiant energy{" "}
        <strong>allows crops to grow in the darkness</strong> of Duskwall. Life
        in the city depends upon these farms, so their delicate radiant plants
        and irrigation systems are watched constantly by specially appointed{" "}
        <strong>deputies of the Watch</strong>.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Barrowcleft = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <NavCampaign />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Barrowcleft;
